import HttpFactory from "~/repository/factory";

export type LifeScoreAvailability = {
  canCompute: boolean;
  blockers: string[];
  missingFields: { key: string; label: string }[];
  // Total de campos do modelo de vida (denominador do % de completude).
  requiredCount: number;
  // Campos já presentes (pode ser > 0 mesmo com blockers).
  presentCount: number;
};

export type LifeScoreResult = {
  score_credito: number;
  score_vida: number;
};

class ScoreModule extends HttpFactory {
  private RESOURCE = "/score";

  async getLifeScoreAvailability(leadId: string): Promise<LifeScoreAvailability> {
    return await this.get<LifeScoreAvailability>(
      `${this.RESOURCE}/${leadId}/life-availability`,
    );
  }

  async requalifyLifeScore(leadId: string): Promise<LifeScoreResult> {
    return await this.post<LifeScoreResult>(
      `${this.RESOURCE}/${leadId}/requalify-life`,
    );
  }
}

export default ScoreModule;
